<template>
  <div>
    <div>
      <v-layout row>
        <v-flex xs10>
          <h3 :style="titleStyle">{{ $t('other_details') }}</h3>
        </v-flex>
        <v-flex
          xs2
          text-xs-right
        >
          <div style="margin-top: -5px;">
            <v-btn
              icon
              small
              @click="dialog = true"
            >
              <v-icon
                small
                :color="theme.trashcan_color"
              >fas fa-edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="ml-2">
      <ul :style="listStyle">
        <li v-if="this.guestDetails.name">{{ $t('receiver') }}: {{ this.guestDetails.name }}</li>
        <li v-if="this.guestDetails.email">{{ $t('email') }}: {{ this.guestDetails.email }}</li>
        <li v-if="this.guestDetails.country_code && this.guestDetails.mobile">{{ $t('mobile') }}: {{ '+' + this.guestDetails.country_code + ' ' + this.guestDetails.mobile }}</li>
      </ul>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
    >
      <v-card :color="theme.login_bg_color">
        <v-card-text class="pa-4">
          <v-layout row>
            <v-flex
              xs12
              sm10
              offset-sm1
              md8
              offset-md2
              lg6
              offset-lg3
              xl6
              offset-xl3
            >
              <v-layout
                row
                align-center
              >
                <v-flex>
                  <span class="main-title">{{ $t('guest_details') }}</span>
                </v-flex>
              </v-layout>
              <div class="mt-3 mb-0">
                <form
                  @submit.prevent="saveGuestDetails"
                  @keydown="form.onKeydown($event)"
                >
                  <v-card-text style="margin-left: -13px;">
                    <v-text-field
                      v-model="form.name"
                      :label="$t('receiver_name')"
                      prepend-icon="person"
                      :error-messages="errors.collect('name')"
                      name="name"
                      v-validate="'required'"
                    />
                    <email-input
                      :form="form"
                      :label="$t('email_ereceipt_purpose')"
                      :v-errors="errors"
                      :value.sync="form.email"
                      name="email"
                      prepend="email"
                      v-validate="'required|email'"
                    ></email-input>
                    <v-layout
                      row
                      align-center
                      mt-3
                      mb-3
                    >
                      <v-flex
                        xs1
                        class="ml-1"
                      >
                        <v-icon size="23px">phonelink_ring</v-icon>
                      </v-flex>
                      <v-flex xs11>
                        <vue-tel-input
                          v-model="form.mobile"
                          name="mobile"
                          :placeholder="$t('mobile_contact_purpose')"
                          defaultCountry="SG"
                          required
                          :maxLen="15"
                          enabledCountryCode
                          validCharactersOnly
                          :wrapperClasses="['mobile-input']"
                          @validate="validateMobile"
                          @open="openMobile"
                        ></vue-tel-input>
                      </v-flex>
                    </v-layout><v-layout
                      v-if="this.form.mobile.length > 0 && !this.mobileIsValid"
                      row
                      align-center
                      style="margin-top: -15px; margin-bottom: 5px;"
                    >
                      <v-flex xs1 class="ml-1"></v-flex>
                      <v-flex xs11 class="ml-1">
                        <span style="font-size: 12px; color: red">Your mobile number is invalid</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card
                    shaped
                    style="border: 1px solid #262626"
                  >
                    <v-card-text>
                      <v-layout
                        row
                        justify-center
                        align-center
                      >
                        <v-flex xs1>
                          <v-icon small>fas fa-info-circle</v-icon>
                        </v-flex>
                        <v-flex
                          xs11
                          class="ml-1"
                        >
                          <span class="info-text">{{ $t('information_contact_purpose' )}}</span>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <div class="text-xs-center mt-4">
                  <v-btn
                    dark
                    :color="theme.btn_color_secondary"
                    type="submit"
                  >
                    {{ $t('save') }}
                  </v-btn>
                  <v-btn
                    flat
                    :color="theme.btn_color_secondary"
                    @click="closeGuestDetails"
                  >
                    {{ $t('close') }}
                  </v-btn>
                </div>
                </form>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-divider class="mt-3 mb-2" :color="theme.orders_divider_color" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

export default {
  data () {
    return {
      form: new Form({
        name: '',
        email: '',
        country_code: '',
        mobile: ''
      }),
      dialog: false,
      mobileIsValid: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('cart', [
      'guestDetails'
    ]),
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        color: this.theme.cart_name2_color
      }
    }
  },
  methods: {
    validateMobile ({ number, isValid, country }) {
      this.mobileIsValid = isValid
      this.form.country_code = country.dialCode
      if (isValid && number.significant) {
        this.form.mobile = number.significant
      }
    },
    openMobile () {
      // Manually set using JS because CSS isn't applying the style
      const dropdownElementStyle = document.getElementsByClassName('dropdown')[0].childNodes[2].style
      if (dropdownElementStyle) {
        dropdownElementStyle.fontSize = "14px"
        dropdownElementStyle.width = "230px"
      }
    },
    closeGuestDetails () {
      this.dialog = false
      this.form.keys().forEach(key => {
        this.form[key] = this.guestDetails[key]
      })
      this.errors.clear()
    },
    async saveGuestDetails () {
      if (await this.formHasErrors()) return
      if (!this.mobileIsValid) {
        return
      }
      this.$store.dispatch('cart/setGuestDetails', {
        name: this.form.name,
        email: this.form.email,
        country_code: this.form.country_code,
        mobile: this.form.mobile
      })
      this.dialog = false
    }
  },
  mounted () {
    // Fill the form with user data.
    this.form.keys().forEach(key => {
      this.form[key] = this.guestDetails[key]
    })
  },
}
</script>

<style scoped>
.main-title {
  font-weight: 800;
}
.mobile-input {
  border-top: 0px !important;
  border-left: 0px !important;
  border-right: 0px !important;
}
.info-text {
  font-size: 14px;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/GuestDetails.vue